module.exports = VueI18n;


//////////////////
// WEBPACK FOOTER
// external "VueI18n"
// module id = 86
// module chunks = 0